export default function Grid_Search() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Grid_Search</h1>
      <p>Content for Grid_Search goes here.</p>
    </div>
  );
}